/**
 * OnboardingLayout Component
 * Main layout wrapper for onboarding pages
 * Includes Header, ProgressBar, and Footer
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import ProgressBar from './ProgressBar';
import Footer from './Footer';

const OnboardingLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <ProgressBar />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 pb-20 sm:pb-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default OnboardingLayout;
